export const StrategyList = Object.freeze([
  { name: 'FIFO', value: 'fifo' },
  { name: 'LIFO', value: 'lifo' },
  { name: 'STRICT_FIFO', value: 'strict_fifo' },
]);

export const Strategy = Object.freeze({
  FIFO: 'fifo',
  LIFO: 'lifo',
  STRICT_FIFO: 'strict_fifo',
});
